import React, { useState, forwardRef, useImperativeHandle } from "react";
import styles from "./ImmunizationTdapViewNew.module.css";
import FormDatePicker from "components/FormDatePicker";
import { DATE_FORMAT_PATTERN } from "pages/enums";

const ImmunizationTdapViewNew = forwardRef(({
  data = {},
  selectedDeclination,
  onChange,
  disabled = false,
  onValidate, setDate }, ref) => {

  const [error, setError] = useState('');

  useImperativeHandle(ref, () => ({
    validate: () => {
      const errors = {};
      if (!selectedDeclination || selectedDeclination === "") {
        if (!data.date1 && !data.date2) {
          errors.dateField = 'At least one of the date fields is required';
          setError(errors.dateField);
          onValidate(errors.dateField);
          return errors;
        }
      }
      setError('');
      onValidate({});
      return null;
    },
  }));

  const setValue = (key, value) => {
    if (key) {
      data[key] = value;
    }

    if (onChange) {
      onChange({ ...data });
    }
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.testRow}>
          <div className={styles.testItem}>
            A. Initial Tdap date {" "}
          </div>
          <div className={styles.testItem}>
            <FormDatePicker
              dateFormat={DATE_FORMAT_PATTERN}
              dateString={data.date1}
              setDate={(value) => {
                data.date1 = value;
                setValue();
              }}
              disabled={disabled}
            />
          </div>
        </div>
        <div className={styles.testRow}>
          <div className={styles.testItem}>
            B. Td/Tdap subsequent dose date {" "}
          </div>
          <div className={styles.testItem}>
            <FormDatePicker
              dateFormat={DATE_FORMAT_PATTERN}
              dateString={data.date2}
              setDate={(value) => {
                data.date2 = value;
                setValue();
              }}
              disabled={disabled}
            />
          </div>

        </div>
        {error && <div className={styles.errorMessages}>{error}</div>}
      </div>
    </>
  );
})

export default ImmunizationTdapViewNew;
